import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20gradient%20abstract%20background%20with%20soft%20flowing%20curves%20and%20comic-inspired%20energy%20lines%2C%20orange%20and%20coral%20warm%20tones%2C%20modern%20minimal%20design%2C%20no%20text%2C%20clean%20composition%20with%20gentle%20light%20effects&width=1800&height=600&seq=cta-bg-comic-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/50 to-background-950/70"></div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开始探索了吗？
        </h2>
        <p className="text-base text-background-200 mb-8 max-w-xl mx-auto leading-relaxed">
          上千部精选漫画等你发现，从韩漫到日漫再到国漫，总有一部适合你
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/korean"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-bold text-base hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即浏览漫画
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 text-background-50 font-bold text-base border border-background-50/30 hover:bg-background-50/25 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}